export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <i className="ri-recycle-line text-3xl text-orange-500"></i>
              <span className="text-2xl font-bold">S2K Waste</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted partner for reliable skip hire and waste management solutions in Kwa Zulu Natal.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Residential Skip Hire</li>
              <li className="text-gray-400 text-sm">Commercial Skip Hire</li>
              <li className="text-gray-400 text-sm">Construction Waste</li>
              <li className="text-gray-400 text-sm">Industrial Waste</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-orange-500 mt-1"></i>
                <a href="tel:+27844606965" className="text-gray-400 text-sm hover:text-orange-500 transition-colors">
                  +27 84 460 6965
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-orange-500 mt-1"></i>
                <a href="mailto:info@s2kwaste.co.za" className="text-gray-400 text-sm hover:text-orange-500 transition-colors">
                  info@s2kwaste.co.za
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                <span className="text-gray-400 text-sm">Kwa Zulu Natal, South Africa</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 S2K Waste Services. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.lerekodigital.co.za"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer"
              >
                Lereko Digital
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
